// export { LotteryModal } from './LotteryModal';
// export type { LotteryModalProps as LotteryModalType } from './LotteryModal';

import { ImageProps } from 'next/image';
import { ThemeLogoType } from 'components/themeLogo';
import dynamic from 'next/dynamic';

export type LotteryModalProps = {
  isOpen: boolean;
  title: string;
  lotteryType: 'primary' | 'secondary' | 'tertiary';
  supplier: string;
  supplierLogo?: ThemeLogoType[];
  logo?: ImageProps;
};

export const LotteryModal = dynamic<LotteryModalProps>(
  () => import('components/modals/lotteryModal/LotteryModal').then((mod) => mod.LotteryModal),
  { ssr: false }
);
